import React from "react";
import fp from "lodash/fp";
import { Row, Col } from "react-bootstrap";

import { maxLength7, minLength7, required } from "validators/validation";

import { withFeeBlockContext } from "../../feeBlockContext";
import TemplateField from "../../templateField";

const EbtBlock = ({ validators, isPaperApplication, formValues }) => {
	const isRequiredEbtAccountNumber =
		+formValues?.ebtCashPerItemFee > 0 ||
		+formValues?.ebtFoodPerItemFee > 0;

	return (
		<>
			<Row>
				<Col md={5}>
					<TemplateField
						name="ebtAccountNumber"
						label="EBT Account #"
						hideRequiredMark={
							!isRequiredEbtAccountNumber || isPaperApplication
						}
						validate={fp.compact([
							minLength7,
							maxLength7,
							isRequiredEbtAccountNumber &&
								!isPaperApplication &&
								required,
						])}
						{...validators.ebtAccountNumber}
					/>
				</Col>
			</Row>
			<Row style={{ marginBottom: 20 }}>
				<Col md={5}>
					<TemplateField
						name="ebtCashPerItemFee"
						label="EBT Cash (Per Item), $"
						hideRequiredMark
						placeholder="0.000000"
						placeholderClassName={
							isPaperApplication
								? "placeholder-value"
								: "placeholder-primary"
						}
						{...validators.ebtCashPerItemFee}
					/>
				</Col>
				<Col md={{ span: 5, offset: 2 }}>
					<TemplateField
						name="ebtFoodPerItemFee"
						label="EBT Food (Per Item), $"
						hideRequiredMark
						placeholder="0.000000"
						placeholderClassName={
							isPaperApplication
								? "placeholder-value"
								: "placeholder-primary"
						}
						{...validators.ebtFoodPerItemFee}
					/>
				</Col>
			</Row>
		</>
	);
};

export default withFeeBlockContext("EBT")(EbtBlock);
